import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Phase 18: Public Onboarding - Senior Profile (Optional)
 * Step 4: Create senior profile
 */
function PublicOnboardingSenior() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [language, setLanguage] = useState('de');
  const [religion, setReligion] = useState('none');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const householdId = sessionStorage.getItem('onboarding_household_id');
    if (!householdId) {
      navigate('/family/onboarding/household');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const householdId = sessionStorage.getItem('onboarding_household_id');
      const deviceId = sessionStorage.getItem('onboarding_device_id');

      await axios.post(`${API}/api/onboarding/senior`, {
        household_id: householdId,
        name: name,
        language: language,
        religion: religion,
        device_id: deviceId || undefined
      });

      navigate('/family/onboarding/invite');
    } catch (err) {
      setError(err.response?.data?.detail || 'Fehler beim Erstellen des Profils');
    } finally {
      setLoading(false);
    }
  };

  const handleSkip = () => {
    navigate('/family/onboarding/invite');
  };

  return (
    <div className="min-h-screen bg-[#050816] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Progress */}
        <div className="mb-8">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-8 h-8 rounded-full bg-[#22C55E] text-white flex items-center justify-center text-sm">✓</div>
            <div className="w-12 h-1 bg-[#22C55E]"></div>
            <div className="w-8 h-8 rounded-full bg-[#22C55E] text-white flex items-center justify-center text-sm">✓</div>
            <div className="w-12 h-1 bg-[#22C55E]"></div>
            <div className="w-8 h-8 rounded-full bg-[#22C55E] text-white flex items-center justify-center text-sm">✓</div>
            <div className="w-12 h-1 bg-[#22C55E]"></div>
            <div className="w-8 h-8 rounded-full bg-[#6DCEE8] text-[#050816] flex items-center justify-center font-bold">4</div>
          </div>
          <p className="text-center text-sm text-neutral-400">Schritt 4 von 5 (Optional)</p>
        </div>

        {/* Card */}
        <div className="bg-neutral-900/80 backdrop-blur-xl rounded-2xl p-8 shadow-2xl border border-neutral-600/40">
          <h2 className="text-3xl font-bold text-[#F9FAFB] mb-2">Senior-Profil</h2>
          <p className="text-[#CBD5F5] mb-6">Erstellen Sie ein Profil für Ihre Angehörigen</p>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-bold text-[#F9FAFB] mb-2">Name</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="z.B. Oma Ayse"
                required
                className="w-full px-4 py-3 bg-neutral-800/50 border-2 border-neutral-600/40 text-[#F9FAFB] placeholder-neutral-500 rounded-xl focus:outline-none focus:ring-4 focus:ring-[#5B4B8A]/50 focus:border-[#5B4B8A] transition-all"
                disabled={loading}
              />
            </div>

            <div>
              <label className="block text-sm font-bold text-[#F9FAFB] mb-2">Sprache</label>
              <select
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                className="w-full px-4 py-3 bg-neutral-800/50 border-2 border-neutral-600/40 text-[#F9FAFB] rounded-xl focus:outline-none focus:ring-4 focus:ring-[#5B4B8A]/50 focus:border-[#5B4B8A] transition-all"
                disabled={loading}
              >
                <option value="de">Deutsch</option>
                <option value="tr">Türkisch</option>
                <option value="en">Englisch</option>
                <option value="ar">Arabisch</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-bold text-[#F9FAFB] mb-2">Religion</label>
              <select
                value={religion}
                onChange={(e) => setReligion(e.target.value)}
                className="w-full px-4 py-3 bg-neutral-800/50 border-2 border-neutral-600/40 text-[#F9FAFB] rounded-xl focus:outline-none focus:ring-4 focus:ring-[#5B4B8A]/50 focus:border-[#5B4B8A] transition-all"
                disabled={loading}
              >
                <option value="none">Keine</option>
                <option value="islam">Islam</option>
                <option value="christian">Christentum</option>
              </select>
            </div>

            {error && (
              <div className="bg-[#EF4444]/10 border border-[#EF4444]/40 text-[#EF4444] px-4 py-3 rounded-xl text-sm">
                <span className="font-semibold">⚠️ {error}</span>
              </div>
            )}

            <div className="space-y-3 pt-2">
              <button
                type="submit"
                className="w-full py-4 bg-gradient-to-r from-[#5B4B8A] to-[#4a3d72] text-white rounded-xl font-bold text-lg shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all duration-300 disabled:opacity-50"
                disabled={loading}
              >
                {loading ? 'Wird erstellt...' : 'Profil erstellen'}
              </button>
              <button
                type="button"
                onClick={handleSkip}
                className="w-full py-3 text-[#6DCEE8] rounded-xl font-semibold text-sm hover:underline"
              >
                ⏩ Überspringen (später hinzufügen)
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PublicOnboardingSenior;
